import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { usePageTitle } from '../utils/usePageTitle';
import api from '../services/api';
import './Login.css';

function Register() {
  usePageTitle('Sign Up');

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [fullName, setFullName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [registrationCode, setRegistrationCode] = useState('');
  const [error, setError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await api.register({
        email,
        password,
        full_name: fullName,
        company_name: companyName,
        registration_code: registrationCode,
      });
      setSubmitted(true);
    } catch (err) {
      const data = err.response?.data || {};
      setError(data.error || 'Registration failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <div className="login-container">
        <div className="login-box" style={{ textAlign: 'center' }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>✓</div>
          <h1 style={{ fontSize: 22, color: '#0f172a', marginBottom: 8 }}>Registration received</h1>
          <p style={{ fontSize: 14, color: '#475569', lineHeight: 1.6, marginBottom: 24 }}>
            Your account has been submitted for admin approval. You will be able to log in once approved.
          </p>
          <div style={{ background: '#fef3c7', border: '1px solid #fde68a', borderRadius: 8, padding: '12px 14px', fontSize: 13, color: '#78350f', marginBottom: 16, textAlign: 'left' }}>
            <strong>Need this expedited?</strong>
            <div style={{ marginTop: 4 }}>
              Contact <a href="mailto:parv@paramounttechnetwork.com" style={{ color: '#78350f', fontWeight: 600 }}>parv@paramounttechnetwork.com</a>
            </div>
          </div>
          <Link to="/login" style={{ color: '#6366f1', fontWeight: 600, textDecoration: 'none', fontSize: 14 }}>
            ← Back to Login
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <div className="login-icon">🎯</div>
          <h1>Request Access</h1>
          <p>Sign up for KeywordIP — admin approval required</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email Address *</label>
            <input
              type="email" value={email} onChange={e => setEmail(e.target.value)}
              required autoComplete="email" disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Password *</label>
            <input
              type="password" value={password} onChange={e => setPassword(e.target.value)}
              required minLength={8} autoComplete="new-password" disabled={loading}
              placeholder="At least 8 characters"
            />
          </div>

          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text" value={fullName} onChange={e => setFullName(e.target.value)}
              autoComplete="name" disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Company</label>
            <input
              type="text" value={companyName} onChange={e => setCompanyName(e.target.value)}
              autoComplete="organization" disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Invitation Code *</label>
            <input
              type="text" value={registrationCode} onChange={e => setRegistrationCode(e.target.value)}
              required disabled={loading}
              placeholder="Provided by admin"
              autoComplete="off"
            />
            <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
              You need an invitation code to sign up. Contact the admin if you don't have one.
            </div>
          </div>

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? '⏳ Submitting...' : 'Request Access'}
          </button>

          {error && (
            <div className="error-message" style={{ marginTop: 14 }}>
              {error}
            </div>
          )}
        </form>

        <div style={{ marginTop: 20, paddingTop: 16, borderTop: '1px solid #e5e7eb', textAlign: 'center', fontSize: 13, color: '#64748b' }}>
          Already have an account?{' '}
          <Link to="/login" style={{ color: '#6366f1', fontWeight: 600, textDecoration: 'none' }}>
            Sign in →
          </Link>
        </div>
      </div>
    </div>
  );
}

export default Register;
